<template>
  <div>
    <!-- Start toolbox -->
    <rabbey-toolbox>
      <div class="mr-5 box">
        <el-input
          suffix-icon="el-icon-search"
          placeholder="# objetivo"
          size="mini"
          style="width: 180px"
          v-model="input"
          v-on:keyup.enter.native="getDataForReport()"
        ></el-input>
      </div>

      <div class="mr-5 box">
        <el-date-picker
          v-model="duedate"
          size="mini"
          type="month"
          style="width: 160px"
          clearable=""
          placeholder="Fecha vencimiento"
        >
        </el-date-picker>
      </div>
      <div class="mr-5 box">
        <el-date-picker
          v-model="date"
          style="width: 160px"
          size="mini"
          type="month"
          clearable=""
          placeholder="Fecha creación"
        >
        </el-date-picker>
      </div>

      <div class="mr-5 box">
        <el-select
          v-loading="loading"
          v-model="employeeId"
          filterable
          clearable
          size="mini"
          placeholder="Colaborador"
          @change="handleChangeEmployee"
        >
          <el-option
            v-for="item in employees"
            :key="item.EmployeeID"
            :label="item.Name"
            :value="item.EmployeeID"
          >
          </el-option>
        </el-select>
      </div>

      <div class="mr-5 box">
        <el-select
          v-model="deparmentId"
          filterable
          clearable
          size="mini"
          placeholder="Departamento"
        >
          <el-option
            v-for="(item, index) in deparments"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>

      <div class="mr-5 box">
        <el-select
          v-model="directionId"
          filterable
          clearable
          size="mini"
          placeholder="Direccion"
          @change="handleChangeDirection"
        >
          <el-option
            v-for="(item, index) in directions"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="mr-5 box">
        <el-select
          v-if="isCEO"
          v-model="TypeObjetive"
          filterable
          clearable
          size="mini"
          placeholder="Tipo"
          @change="handleChangeType"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </rabbey-toolbox>

    <!-- End toolbox -->

    <el-row :gutter="40">
      <template v-for="(stat, index) in statistics">
        <el-col :key="index" :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
          <CardSatCmi
            v-if="
              stat['Perspective'] !== undefined &&
              stat['Perspective']['Name'] !== undefined
            "
            :title="stat['Perspective']['Name']"
            :percent="parseInt(stat.Percentaje)"
            :loading.sync="loadingStadistic"
            :icon="getIconST(stat['Perspective']['Name'])"
            :objetive-completed="stat.ObjetiveCompleted"
            :objetive-total="stat.ObjetiveTotal"
            :task-completed="stat.TaskCompleted"
            :task-total="stat.TaskTotal"
            countTooltipText="Porcentaje de la perspectiva"
          >
          </CardSatCmi>
        </el-col>
      </template>
    </el-row>
    <!-- End stats -->
    <div v-if="totalIbejctives">
      <label>TOTAL DE OBJECTIVOS: {{ totalIbejctives.length }}</label>
    </div>
    <el-row>
      <el-alert
        style="background-color: tan"
        title="Tomar en cuenta lo siguiente"
        description="Para agregar objetivos y tareas debe de hacerlo desde Odjetivos Gantt"
        type="warning"
        :closable="false"
        effect="dark"
        show-icon
      >
      </el-alert>
    </el-row>
    <!-- Start table -->
    <el-card :v-loading="loadingStadistic">
      <el-row type="flex" :gutter="5" justify="start">
        <el-col :span="4">
          <el-switch
            v-model="PorDirection"
            active-text="Por Dirección"
          ></el-switch>
        </el-col>

        <el-col :span="4">
          <el-tooltip>
            <div slot="content">
              Pendientes: Todas los objetivos que tienen cumplimiento por debajo
              de 100%
            </div>
            <el-switch
              v-model="Pending"
              active-text="Pendientes"
              inactive-text="Todos"
            >
            </el-switch>
          </el-tooltip>
        </el-col>

        <el-col :span="4">
          <el-switch v-model="Byme" active-text="Creados por mi"></el-switch>
        </el-col>

        <el-col :span="4">
          <el-switch v-model="Present" active-text="Al dia"></el-switch>
        </el-col>
        <el-col :span="1">
          <el-button
            type="primary"
            icon="el-icon-document"
            size="mini"
            @click="exportToExcel"
          >
            Exportar a Excel
          </el-button>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-table
            :data="reportData"
            style="width: 100%"
            :show-header="false"
            :row-class-name="tableRowClassName"
            default-expand-all
            v-loading="loadingStadistic"
          >
            <el-table-column :width="40">
              <template slot-scope="scope">
                <el-dropdown trigger="click" @command="handleCommand">
                  <span class="el-dropdown-link">
                    <i class="mdi mdi-menu"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      disabled
                      :command="{
                        row: scope.row.Perpective,
                        command: 'create-goal'
                      }"
                    >
                      <i class="el-icon-circle-plus-outline"></i>
                      Agregar objectivo
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
            <el-table-column
              type="expand"
              :default-expand-all="true"
              row-class-name="testClass"
              :width="40"
            >
              <!--  -->
              <!-- Tabla de Objectivos -->
              <template slot-scope="props">
                <el-table
                  ref="ObjectivesTable"
                  :data="props.row.Objetives"
                  style="width: 100%; padding: 0"
                  :row-class-name="tableRowClassNameObjetive"
                  :v-loading="loadingStadistic"
                  :default-sort="{
                    prop: 'DateEnd',
                    order: 'descending'
                  }"
                >
                  <el-table-column
                    :width="40"
                    fixed
                    align="center"
                    margin-left="150"
                  >
                    <template slot="header" slot-scope="scope">
                      <i class="el-icon-setting" :key="scope.$index"></i>
                    </template>
                    <template slot-scope="scope">
                      <el-dropdown trigger="click" @command="handleCommand">
                        <span class="el-dropdown-link">
                          <i class="mdi mdi-menu"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            v-for="(action, index) in actions"
                            :key="index"
                            :command="{
                              index: scope.$index,
                              row: scope.row,
                              column: scope.column,
                              command: action.command,
                              task: true,
                              perspective: props
                            }"
                            :icon="action.icon"
                            :disabled="action.disabled"
                            >{{ action.label }}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </template>
                  </el-table-column>
                  <el-table-column type="expand" :width="40">
                    <!-- tabla de tareas -->
                    <template slot-scope="Objectivos">
                      <el-table
                        ref="TasksTable"
                        :data="Objectivos.row.tasks"
                        style="width: 100%"
                        class="actions"
                        :v-loading="loadingStadistic"
                      >
                        <el-table-column :width="40">
                          <template slot="header" slot-scope="scope">
                            <i class="el-icon-setting" :key="scope.$index"></i>
                          </template>
                          <template slot-scope="scope">
                            <el-dropdown
                              trigger="click"
                              @command="handleCommand"
                            >
                              <span class="el-dropdown-link">
                                <i class="mdi mdi-menu"></i>
                              </span>
                              <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                  v-for="(action, index) in taskActions"
                                  :key="index"
                                  :command="{
                                    index: scope.$index,
                                    row: scope.row,
                                    column: scope.column,
                                    command: action.command,
                                    task: true,
                                    objectivo: Objectivos,
                                    perspective: props
                                  }"
                                  :icon="action.icon"
                                  >{{ action.label }}
                                </el-dropdown-item>
                              </el-dropdown-menu>
                            </el-dropdown>
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="NO"
                          prop="ID"
                          class-name="bold"
                          :width="90"
                        />
                        <el-table-column
                          label="Tarea"
                          prop="Name"
                          :min-width="290"
                        >
                          <template slot-scope="{ row: { Name, IsTaskRead } }">
                            <div v-if="IsTaskRead">{{ Name }}</div>
                            <el-badge
                              v-else
                              value="Nuevo"
                              class="item"
                              type="success"
                            >
                              <div>{{ Name }}</div>
                            </el-badge>
                          </template>
                        </el-table-column>
                        <el-table-column label="" prop="" :min-width="170" />
                        <el-table-column label="Estatus %" :min-width="90">
                          <template slot-scope="myscope">
                            <div v-if="myscope.row.PercentageProsposal > 0">
                              <el-badge
                                :value="myscope.row.PercentageProsposal"
                                :max="99"
                                :type="setPercentageProsposalType(myscope.row)"
                                class="item"
                              >
                                <a
                                  @click="AcceptedValue(myscope.row)"
                                  style="cursor: pointer"
                                  >{{ myscope.row.Percentage }},</a
                                >
                              </el-badge>
                            </div>
                            <div
                              v-else-if="myscope.row.PercentageProsposal === 0"
                            >
                              <p>{{ myscope.row.Percentage }}%</p>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column label="" prop="" :min-width="140" />
                        <el-table-column
                          prop="Typetask"
                          class-name="bold"
                          :width="140"
                          label="Tipo"
                        >
                          <template slot-scope="{ row: { Typetask } }">
                            <el-tag
                              v-if="Typetask == 'ESTRATEGICO'"
                              type="warning"
                              close-transition
                              >{{ Typetask }}
                            </el-tag>
                            <el-tag v-else type="info" close-transition>{{
                              Typetask
                            }}</el-tag>
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="Creación"
                          prop="CreatedAt"
                          :width="125"
                          :formatter="
                            (e) => formatDate(e.CreatedAt, 'DD/MM/YYYY')
                          "
                        />
                        <el-table-column
                          label="Inicio"
                          prop="InitialDate"
                          sortable
                          :width="200"
                          :formatter="
                            (e) => formatDate(e.InitialDate, 'DD/MM/YYYY')
                          "
                        />
                        <el-table-column
                          label="Compromiso"
                          :min-width="165"
                          prop="LimitDate"
                          :sortable="true"
                          :formatter="
                            (e) => formatDate(e.LimitDate, 'DD/MM/YYYY')
                          "
                        />

                        <el-table-column
                          prop="DiasRetrasados"
                          class-name="bold"
                          :min-width="125"
                          label="Dias de Retraso"
                        >
                          <template slot-scope="{ row: { DiasRetrasados } }">
                            <el-tag
                              v-if="DiasRetrasados === 0"
                              type="success"
                              close-transition
                              >{{ DiasRetrasados }}
                            </el-tag>

                            <el-tag v-else type="danger" close-transition
                              >{{ DiasRetrasados }}
                            </el-tag>
                          </template>
                        </el-table-column>

                        <el-table-column
                          prop="Responsable"
                          label="Responsable"
                          class-name="bold"
                          :min-width="230"
                          aling="center"
                        >
                          <template
                            #default="{ row: { Responsable, UserUrlImage } }"
                          >
                            <div class="flex">
                              <el-avatar
                                class="box"
                                size="small"
                                :src="UserUrlImage"
                              ></el-avatar>
                              <span class="box ml-5">{{ Responsable }}</span>
                            </div>
                          </template>
                        </el-table-column>

                        <el-table-column
                          prop="CreatedBy"
                          :min-width="230"
                          label="Creador"
                        >
                          <template #default="{ row }">
                            <div class="flex">
                              <el-avatar
                                v-if="row.OwnerUrlImage"
                                class="box"
                                size="small"
                                :src="row.OwnerUrlImage"
                              ></el-avatar>
                              <el-avatar
                                v-else
                                class="box"
                                size="small"
                                src="/static/images/avatar-2.jpg"
                              ></el-avatar>
                              <span class="box ml-5">{{
                                getUserCreatedName(row, "CreatedBy")
                              }}</span>
                            </div>
                          </template>
                        </el-table-column>

                        <!-- <el-table-column
                          prop="CreatedBy"
                          :min-width="250"
                          label="Creador"
                          :formatter="e => getUserCreatedName(e, 'CreatedBy')"
                        /> -->
                      </el-table>
                    </template>
                    <!-- fin tabla de tareas -->
                  </el-table-column>
                  <el-table-column
                    prop="ID"
                    label="ID"
                    class-name="bold"
                    row-class-name="obbox"
                    width="90"
                    aling="center"
                  />
                  <el-table-column
                    prop="Name"
                    label="Name"
                    class-name="bold"
                    :min-width="290"
                    align="left"
                  >
                    <template slot-scope="{ row: { Name, IsObjectiveRead } }">
                      <div v-if="IsObjectiveRead">{{ Name }}</div>
                      <el-badge
                        v-else
                        value="Nuevo"
                        class="item"
                        type="success"
                      >
                        <div>{{ Name }}</div>
                      </el-badge>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="Direcction"
                    label="Direccion"
                    class-name="bold"
                    :min-width="170"
                    aling="center"
                  >
                    <template
                      slot-scope="{ row: { Direcction, DirectionColor } }"
                    >
                      <span :style="`color: ${DirectionColor}`">{{
                        Direcction
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="Percentage"
                    class-name="bold"
                    :min-width="90"
                    label="Estatus %"
                  >
                    <template slot-scope="{ row: { Percentage } }">
                      <el-tag
                        v-if="Percentage === 100"
                        type="success"
                        close-transition
                        >{{ Percentage }} %</el-tag
                      >
                      <el-tag
                        v-else-if="Percentage >= 75 && Percentage <= 99"
                        type="warning"
                        close-transition
                        >{{ Percentage }} %</el-tag
                      >
                      <el-tag
                        v-else-if="Percentage <= 74"
                        type="danger"
                        close-transition
                        >{{ Percentage }} %</el-tag
                      >
                      <el-tag v-else type="info" close-transition
                        >{{ Percentage }} %</el-tag
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="TypeObjetive"
                    class-name="bold"
                    :width="140"
                    label="Tipo"
                  >
                    <template slot-scope="{ row: { TypeObjetive } }">
                      <el-tag
                        v-if="TypeObjetive == 'ESTRATEGICO'"
                        type="warning"
                        close-transition
                        >{{ TypeObjetive }}
                      </el-tag>
                      <el-tag v-else type="info" close-transition>{{
                        TypeObjetive
                      }}</el-tag>
                    </template>
                  </el-table-column>

                  <el-table-column
                    class-name="bold"
                    label="Por aprobacion"
                    :width="140"
                  >
                    <template slot-scope="scope">
                      <pendding-incator
                        :tasks="scope.row.tasks"
                      ></pendding-incator>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="DateInitDisplay"
                    label="Fecha de inicio"
                    class-name="bold"
                    aling="center"
                    :sortable="true"
                    :width="180"
                  />
                  <el-table-column
                    prop="DateEnd"
                    column-key="DateEnd"
                    label="Fecha Compromiso"
                    class-name="bold"
                    aling="center"
                    :width="180"
                    sort-by="DateEnd"
                    :sortable="true"
                  >
                    <span slot-scope="{ row: { DateEnd } }">
                      <i class="el-icon-time"></i>
                      {{ formatDate(DateEnd, "DD/MM/YYYY") }}
                    </span>
                  </el-table-column>
                  <el-table-column
                    prop="DiasRetrasados"
                    class-name="bold"
                    :min-width="125"
                    label="Dias de Retraso"
                  >
                    <template slot-scope="{ row: { DiasRetrasados } }">
                      <el-tag
                        v-if="DiasRetrasados === 0"
                        type="success"
                        close-transition
                        >{{ DiasRetrasados }}
                      </el-tag>

                      <el-tag v-else type="danger" close-transition
                        >{{ DiasRetrasados }}
                      </el-tag>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="Responsable"
                    label="Responsable"
                    class-name="bold"
                    :min-width="230"
                    aling="center"
                  >
                    <template #default="{ row: { Responsable, UserUrlImage } }">
                      <div class="flex">
                        <el-avatar
                          class="box"
                          size="small"
                          :src="UserUrlImage"
                        ></el-avatar>
                        <span class="box ml-5">{{ Responsable }}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="Owner"
                    label="Creador"
                    aling="center"
                    class-name="bold"
                    :min-width="230"
                  >
                    <template #default="{ row }">
                      <div class="flex">
                        <el-avatar
                          v-if="row.OwnerUrlImage"
                          class="box"
                          size="small"
                          :src="row.OwnerUrlImage"
                        ></el-avatar>
                        <el-avatar
                          v-else
                          class="box"
                          size="small"
                          src="/static/images/avatar-2.jpg"
                        ></el-avatar>
                        <span class="box ml-5">{{
                          getUserCreatedName(row, "Owner")
                        }}</span>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
              <!-- fin tabla de objetivos -->
            </el-table-column>

            <el-table-column
              class="hperspetiva"
              prop="Perpective.Name"
              :width="130"
              aling="center"
            >
            </el-table-column>
            <el-table-column
              class="hperspetiva"
              prop="Objetive"
              :min-width="185"
              aling="center"
            />
            <el-table-column
              class="hperspetiva"
              prop="Direction"
              :min-width="120"
              aling="center"
            />
            <el-table-column
              class="hperspetiva"
              prop="PercentageLabel"
              aling="center"
              :width="90"
            />
            <el-table-column
              class="hperspetiva"
              prop="Pendding"
              label="Pendientes"
              aling="center"
              :width="180"
            />
            <el-table-column
              class="hperspetiva"
              prop="DateInit"
              aling="left"
              :width="148"
            />
            <el-table-column
              class="hperspetiva"
              prop="DateEnd"
              sortable
              aling="left"
              :width="148"
            />
            <el-table-column
              class="hperspetiva"
              prop="Responsable"
              :min-width="150"
              aling="center"
            />
            <el-table-column
              prop="Creator"
              class="hperspetiva"
              label="Creador"
              :width="100"
            >
              <template slot="header" slot-scope="scope">
                <span :key="scope.$index">Creador</span>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-card>
    <!-- End table -->

    <!-- Drawers -->
    <TaskForm
      ref="taskForm"
      :currentActionSelected="this.currentAction"
      @submit-success="getDataForReport"
    >
    </TaskForm>

    <ObjectiveForm
      ref="newObjectiveForm"
      @submit-success="getDataForReport"
    ></ObjectiveForm>
  </div>
</template>

<script>
import ObjectiveForm from "./ObjectiveForm.vue";
import TaskForm from "./TaskForm.vue";
import { formatDate, formatArrayToElSelect } from "@/utils";
import { TARGET_ACTIONS, TASK_ACTIONS } from "./ObjetiveOptions";
// import CardTotalOriginal from "@/components/CardTotalOriginal.vue";
import CardSatCmi from "@/components/cmi/CardStatCmi.vue";
import PenddingIncator from "../../../../components/cmi/PenddingIncator.vue";
import { COMPANYS } from "@/const";
//import Type from '@/models/deals/Type';
import { exportExcel } from "@/helpers/exportExcel";

export default {
  name: "ObjectiveList",
  components: {
    ObjectiveForm,
    TaskForm,
    PenddingIncator,
    CardSatCmi
  },
  filters: {
    strippedContent: function (string) {
      return string.replace(/<\/?[^>]+>/gi, " ");
    }
  },
  data() {
    // const { CompanySelected } = this.$store.state.user.user;
    return {
      Present: false,
      input: "",
      duedate: "",
      date: null,
      PorDirection: false,
      Byme: false,
      Pending: false,
      directions: [],
      directionId: null,
      TypeObjetive: "",
      deparments: [],
      deparmentId: null,
      statistics: [],
      loadingStadistic: true,
      employeeId: "",
      employees: [],
      DirID: 0,
      DepID: 0,
      Employee: 0,
      loading: false,
      loadingUI: true,
      actions: TARGET_ACTIONS,
      taskActions: TASK_ACTIONS,
      DirecctionID: "",
      reportData: [],
      selectionLabel: "",
      Finance: 0,
      Customer: 0,
      Internal: 0,
      Development: 0,
      FinanceLabel: "",
      CustomerLabel: "",
      InternalLabel: "",
      DevelopmentLabel: "",
      currentAction: "",
      StatusFiltered: "",
      totalIbejctives: null,
      options: [
        {
          value: "GERENCIAL",
          label: "GERENCIAL"
        },
        {
          value: "ESTRATEGICO",
          label: "ESTRATEGICOS"
        }
      ],
      columnsData: [],
      columnNamesExport: []
    };
  },
  watch: {
    currentCompany: function () {
      this.loadingStadistic = true;
      this.getDataForReport();
    },
    // eslint-disable-next-line
    PorDirection: function (value) {
      //console.log("By me: ",value)
      this.loadingStadistic = true;
      this.getDataForReport();
    },
    // eslint-disable-next-line
    Byme: function (value) {
      //console.log("By me: ",value)
      this.loadingStadistic = true;
      this.getDataForReport();
    },
    date: function () {
      this.loadingStadistic = true;
      this.getDataForReport();
    },
    duedate: function () {
      this.loadingStadistic = true;
      this.getDataForReport();
    },
    Pending: function () {
      this.loadingStadistic = true;
      this.getDataForReport();
      //this.setSwichMyObjectives();
    },
    Present() {
      this.loadingStadistic = true;
      this.getDataForReport();
    }
  },
  mounted() {
    const employeeId = this.currentUser.EmployeeId;
    if (
      employeeId === null ||
      employeeId <= 0 ||
      employeeId === undefined ||
      employeeId === ""
    ) {
      this.$alert("Su usuario no tiene empleado asignado.", "Alerta", {
        confirmButtonText: "OK",
        type: "error"
      });
    }
    this.validateCompany();
    this.getDataForReport();
  },
  created() {
    this.getEmployees();
    this.getDirections();
  },
  methods: {
    formatDate,
    formatArrayToElSelect,
    validateCompany() {
      // esta validacion es para evitar cruze de tareas por empersa
      if (this.currentCompany !== COMPANYS.TB) {
        // commentvalidateCompany
        this.$router.push("/");
      }
    },

    getEmployees() {
      let uri = "";
      const company = this.currentCompany;
      const employeeId = this.currentUser.EmployeeId;

      if (this.directionId > 0) {
        uri = `/api/Employees/GetEmployeeByCriteria?DepartmentID=${this.deparmentId}&DirectionID=${this.directionId}`;
      } else {
        uri = `/api/CMI/Objetives/GetUsersObjetivos?CompanySelected=${company}&employeeid=${employeeId}`;
      }

      this.$http
        .get(uri)
        .then((response) => {
          this.employees = response.data;
        })
        .catch(() => {});
    },
    filterTag(value, row) {
      return row.tag === value;
    },
    HandlerUpdateTask() {
      this.getDataForReport();
      this.clickSelectedSettion();
    },
    filterValueHtmlToText(text) {
      return text.replace(/<\/?[^>]+>/gi, " ");
    },
    SaveAfterAceptWhoCanChange(row) {
      const apiAllow = `/api/CMI/Task/allowPercentage`;
      this.$prompt(
        "Por favor digita un comentario de confirmación",
        "Message de confirmación",
        {
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              if (instance.inputValue) {
                this.$http
                  .post(apiAllow, {
                    comment: instance.inputValue,
                    taskid: row.ID
                  })
                  .then(() => {
                    this.getDataForReport();
                    this.clickSelectedSettion();
                    done();
                  })
                  .catch((err) => {
                    this.$message({ type: "danger", message: err });
                  });
              } else {
                this.$message({
                  type: "danger",
                  message: "Debes de digitar un comentario valido"
                });
              }
            }
            if (action === "cancel") {
              done();
            }
          }
        }
      ).catch(() => {
        this.$message({
          type: "info",
          message: "Confirmacion cancelada"
        });
      });
    },
    AcceptedValue(row) {
      const { ResponsableId } = row;
      const { ID } = row;
      const RequesterId = this.currentUser.EmployeeId;
      this.$http
        .post(
          `/api/CMI/Task/canchangeTask?requesterId=${RequesterId}&ResponsableId=${ResponsableId}&TaskId=${ID}`
        )
        .then(({ data }) => {
          if (data) {
            this.SaveAfterAceptWhoCanChange(row);
          } else {
            this.$message({
              type: "info",
              message: "Usted no puede autorizar este cambio"
            });
          }
        });
    },
    handleCommand(action) {
      if (action.command === "create-goal") {
        // this is for add new objetive
        this.$refs.newObjectiveForm.show(action.row, false, true, true);
        return;
      }

      // Eliminar objetivo
      if (action.command === "view-edit-objetive-eliminar") {
        this.$confirm(
          "¿Esta seguro que desea remover este objetivo?",
          "Mensaje de confirmacion",
          {
            confirmButtonText: "Si",
            cancelButtonText: "Cancelar",
            type: "warning"
          }
        )
          .then((op) => {
            if (op === "confirm") {
              this.loading = true;
              const { ID } = action.row;
              const apiDelete = `/api/CMI/Objetives/delete?id=${ID}`;
              this.$http.post(apiDelete).then(() => {
                this.$message({
                  type: "success",
                  message: "Objetivo removido"
                });
                this.getDataForReport();
              });
            }
          })
          .catch((e) => {
            this.$message({
              type: "info",
              message: e
            });
          });
        return;
      }

      // Si task es true quiere decir que la acciones viene de tareas.
      if (action.task) {
        // Eliminar una tarea.
        if (action.command === "view-task-delete") {
          this.$confirm(
            "¿Esta seguro que desea remover esta tarea?",
            "Mensaje de confirmacion",
            {
              confirmButtonText: "Si",
              cancelButtonText: "Cancelar",
              type: "warning"
            }
          ).then((op) => {
            if (op === "confirm") {
              this.loadingUI = true;

              this.$http
                .delete(`/api/CMI/Task/Delete?TaskID=${action.row.ID}`)
                .then((resp) => {
                  this.$message({
                    type: "success",
                    message: resp.data
                  });
                  this.getDataForReport();
                })
                .catch((err) => {
                  this.loadingUI = false;
                  console.error(err);
                });
            }
          });
          return;
        }

        // Editar un objetivo.
        if (action.command === "view-edit-objetive") {
          action.row.IsObjectiveRead = true;

          this.$http
            .get("/api/CMI/Objetives/ReadObjective", {
              params: { ObjectiveID: action.row.ID }
            })
            .then(() => {
              this.$refs.ObjectivesTable.doLayout();
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err
              });
            });

          const data = {
            perspectiveName: this.reportData.filter(
              (r) => r.Perpective.Id === action.row.PerpectiveId
            )[0].Perpective.Name,
            ...action.row
          };
          this.$refs.newObjectiveForm.show(data, false, true);
          return;
        }

        // Selecione la opcion de ver
        if (action.command === "view-see-objetive") {
          action.row.IsObjectiveRead = true;

          this.$http
            .get("/api/CMI/Objetives/ReadObjective", {
              params: { ObjectiveID: action.row.ID }
            })
            .then(() => {
              this.$refs.ObjectivesTable.doLayout();
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err
              });
            });

          const data = {
            perspectiveName: this.reportData.filter(
              (r) => r.Perpective.Id === action.row.PerpectiveId
            )[0].Perpective.Name,
            ...action.row
          };
          this.$refs.newObjectiveForm.show(data, false, false);
          this.NewObjective = false;
          return;
        }
        // Task Secttion
        if (action.command === "view-task-edit") {
          const data = {
            task: action.row,
            objective: action.objectivo
          };
          action.row.IsTaskRead = true;
          this.$http
            .get("/api/CMI/Task/ReadTask", {
              params: { TaskID: action.row.ID }
            })
            .then(() => {
              this.$refs.TasksTable.doLayout();
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err
              });
            });

          this.$refs.taskForm.show(data, true, false, true);
          //console.log("action.command 4: ", typeof action.command, action.command)
          this.currentAction = action.command;
          return;
        }
        //Ver una tarea
        if (action.command === "view-task-view") {
          //console.log("Action: ",action);
          const data = {
            task: action.row,
            objective: action.objectivo
          };
          action.row.IsTaskRead = true;
          this.$http
            .get("/api/CMI/Task/ReadTask", {
              params: { TaskID: action.row.ID }
            })
            .then(() => {
              this.$refs.TasksTable.doLayout();
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err
              });
            });
          //console.log("view data: ", data);
          this.$refs.taskForm.show(data, true, false, false);
          //console.log("action.command 5: ", typeof action.command, action.command)
          this.currentAction = action.command;
          return;
        }

        if (action.command === "task-agregar-nueva") {
          //console.log("action: ", action);
          this.$refs.taskForm.show(action.row, false, true);
          //console.log("action.command 6: ", typeof action.command, action.command)
          this.currentAction = action.command;
          return;
        }

        if (action.command === "view-task-evidence") {
          //console.log("action from OjectivesList: ", action);
          this.$refs.taskForm.openFile(action.row.DocumentURL);
          //this.$refs.taskForm.show(action.row, false, true);
          //console.log("action.command 7 ", typeof action.command, action.command)
          this.currentAction = action.command;
          return;
        }
      }
    },
    getStadistict() {
      this.loadingStadistic = true;
      let params = {
        TypeObjetive: this.StatusFiltered,
        CompanyID: this.currentCompany,
        DirectionID: this.directionId,
        DirecctionID: this.directionId,
        DepartmentID: this.deparmentId,
        DeparmentID: this.deparmentId,
        ResponsableID: this.employeeId === "" ? undefined : this.employeeId,
        PorDirection: this.PorDirection,
        Byme: this.Byme,
        DueDate: this.duedate === "" ? null : this.duedate,
        Date: this.date === "" ? null : this.date,
        Input: this.input,
        Pending: this.Pending,
        Present: this.Present
      };

      if (params.DueDate === null) {
        params.DueDate = "null";
      }

      this.$http
        .get(`/api/CMI/Objetives/GetStadistic`, {
          timeout: 10 * 60 * 1000,
          params
        })
        .then(({ data }) => {
          this.statistics = data;
        })
        .finally(() => {
          this.loadingStadistic = false;
        });
    },
    getDataForReport() {
      this.validateCompany();
      this.loadingUI = true;
      this.getStadistict();
      this.$http
        .get(`/api/CMI/Objetives/ReportObjetiveByCompany`, {
          timeout: 10 * 60 * 1000,
          params: {
            TypeObjetive: this.TypeObjetive,
            CompanyID: this.currentCompany,
            DirecctionID: this.directionId,
            DepartmentID: this.deparment,
            ResponsableID: this.employeeId,
            PorDirection: this.PorDirection,
            Byme: this.Byme,
            DueDate: this.duedate,
            Date: this.date,
            Input: this.input,
            Pending: this.Pending,
            Present: this.Present
          }
        })
        .then((resp) => {
          this.columnsData = [];
          let prueba = [];
          //this.columnNamesExport = [];
          this.reportData = resp.data;
          this.ExtractLabelsAndValues(resp.data);
          this.loadingUI = false;
          //this.columnNamesExport.push( resp.data[1].Objetives[1].tasks[1].Responsable);
          //console.log("console log columnNames",this.columnNamesExport);
          resp.data.forEach((dataReal) => {
            dataReal.Objetives.forEach((dataReal2) => {
              //this.columnsData.push(dataReal2.tasks)
              dataReal2.tasks.forEach((dataReal3) =>
                //dataReal3.Responsable
                //console.log("CONSOLE LOG DATAREAL 3: ",dataReal3.Responsable)
                prueba.push(dataReal3)
              );
              //console.log("CONSOLE LOG FOR DE FOR: ",dataReal2)
            });
            //console.log("PRIMER CONSOLE LOG FOR: ", dataReal.Objetives)
          });
          this.columnsData = prueba.map((e) => [
            e.ID,
            e.Name,
            e.Percentage,
            e.Typetask,
            e.CreatedAt,
            e.LimitDate,
            e.DiasRetrasados,
            e.Responsable
          ]);
          /*this.columnsData = resp.data.map((dataReal) => {
            dataReal.Objetives.map((dataReal2) => {
              dataReal2.Responsable
              dataReal2.Percentage
            });
            //console.log("DATA MAP: ",dataReal)
          });*/
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err.message
          });
        });
      this.getEmployees();
    },
    getObjectiveByDirection() {
      this.validateCompany();
      this.loadingUI = true;
      this.$http
        .get(`/api/CMI/Objetives/GetObjectiveByDirecctionId`, {
          timeout: 10 * 60 * 1000,
          params: {
            directionId: this.directionId
          }
        })
        .then((resp) => {
          // console.log("Data de los objetivos: ", resp.data);
          this.totalIbejctives = resp.data;
          // this.reportData = resp.data;
          // this.ExtractLabelsAndValues(resp.data);
          this.loadingUI = false;
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err.message
          });
        });
      this.getEmployees();
    },
    //filtrando los pendientes
    setSwichMyObjectives() {
      this.loadingUI = true;
      this.getStadistict();
      this.$http
        .get(`/api/CMI/Objetives/ReportObjetivePending`, {
          timeout: 10 * 60 * 1000,
          params: {
            CompanyID: this.currentCompany,
            TypeObjetive: this.TypeObjetive,
            DirecctionID: this.directionId,
            DepartmentID: this.deparment,
            ResponsableID: this.employeeId,
            PorDirection: this.PorDirection,
            Byme: this.Byme,
            DueDate: this.duedate,
            Date: this.date,
            Input: this.input,
            Pending: this.Pending
          }
        })
        .then((resp) => {
          this.reportData = resp.data;
          this.ExtractLabelsAndValues(resp.data);
          this.loadingUI = false;
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err.message
          });
        });
      this.getEmployees();
    },
    ExtractLabelsAndValues(response) {
      this.Finance = response[0].Percentage;
      this.Customer = response[1].Percentage;
      this.Internal = response[2].Percentage;
      this.Development = response[3].Percentage;
      // extract names
      this.FinanceLabel = response[0].Perpective.Name;
      this.CustomerLabel = response[1].Perpective.Name;
      this.InternalLabel = response[2].Perpective.Name;
      this.DevelopmentLabel = response[3].Perpective.Name;
    },
    /**
     * Desplegar objetivo
     *
     **/
    clickSelectedSettion() {
      var filter = Array.prototype.filter;
      var elementos = document.querySelectorAll(".cell");
      var textElement = filter.call(elementos, (e) => {
        return e.innerHTML.startsWith(this.selectionLabel);
      });
      const tr = textElement[0].offsetParent.parentElement;
      tr.children[0].children[0].children[0].click();
    },
    // eslint-disable-next-line
    tableRowClassName({ row, rowIndex }) {
      return `row-index-${rowIndex}`;
    },
    // eslint-disable-next-line
    tableRowClassNameObjetive({ row, rowindex }) {
      let rowclass = `row-obj-index-${rowindex} ${
        row.tasks.length === 0 ? "dueded" : ""
      }`;
      return rowclass;
    },
    handleChangeDirection(directionId) {
      this.directionId = directionId;
      if (directionId) {
        this.getObjectiveByDirection();
        this.getDepartaments();
      }
      this.getDataForReport();
    },
    handleChangeType(TypeObjetive) {
      this.TypeObjetive = TypeObjetive;
      this.getDataForReport();
    },
    handleChangeEmployee(employee) {
      this.employeeId = employee;
      this.getDataForReport();
    },
    getDirections() {
      this.$http
        .get("/api/Directions/DirectionsByCompany", {
          params: {
            company: this.currentCompany
          }
        })
        .then((response) => {
          this.directions = this.formatArrayToElSelect(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getDepartaments() {
      this.$http
        .get("/api/Directions/DepartmentByDirecctionID", {
          params: {
            DirecctionId: this.directionId
          }
        })
        .then((response) => {
          this.deparments = this.formatArrayToElSelect(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getUserCreatedName(row, col) {
      const user = this.$store.getters["user/getUserById"](row[col]);
      return user !== undefined ? user.FullName : "";
    },
    setPercentageProsposalType(row) {
      const { CreatedBy } = row;
      const { UserID } = this.currentUser;
      if (UserID === CreatedBy) {
        return "danger";
      }
      return "warning";
    },
    getIconST(name) {
      if (name === "Financiera") return "el-icon-bank-card accent-text";
      else if (name === "Del cliente") return "el-icon-s-custom success-text";
      else if (name === "Procesos internos") return "el-icon-coin warning-text";
      else if (name === "Desarrollo y Aprendizaje")
        return "el-icon-setting purple-text";
    },
    async exportToExcel() {
      let columnNames = [
        "NO",
        "Nombre",
        "Estatus",
        "Tipo",
        "Fecha Creacion",
        "Fecha Compromiso",
        "Dias de Retraso",
        "Responsable"
      ];
      let columns = this.columnsData;
      let fileTitle = "Lista de Objetivos";

      await exportExcel(columnNames, columns, fileTitle);
    }
  },
  computed: {
    isCEO() {
      return this.currentUser.Roles.some((rol) => rol.Name == "CEO");
    }
  }
};
</script>

<style lang="scss">
.dueded {
  color: #f7ba2a;
}
.bold {
  font-weight: bold;
}
.finanzal {
  background-color: #b1cefe !important;

  span {
    color: #5f8fdf !important;
  }
}

.customer {
  background-color: #e7faf0 !important;

  span {
    color: #13ce66 !important;
  }
}

.process {
  background-color: #fef8ea !important;

  span {
    color: #f7ba2a !important;
  }
}

.development {
  background-color: #f5e9fd !important;

  span {
    color: #c26fcf !important;
  }
}

.current-is-owner {
  background-color: #290a3d !important;

  span {
    color: #c9a9ce !important;
  }
}

.current-not-is-owner {
  background-color: #290a3d !important;

  span {
    color: #c9a9ce !important;
  }
}

.purple-text {
  color: #c26fcf !important;
}
</style>

<style lang="scss" scope>
/* .dropdownoption {
  padding-left: 3px;
  padding-bottom: 2px;
} */

.item {
  margin-top: 10px;
  margin-right: 40px;
  padding: 8px;
}

/* .box-number {
  flex: 1;
  flex-direction: "row";
  justify-content: space-between;
  text-align: center;
  margin-bottom: 35px;
  margin-left: -47px;
} */

@mixin common() {
  font-size: 1.1rem;
  font-weight: 800;
}

.obbox {
  tr > {
    font-size: 4rem !important;
  }
}
.testClass {
  padding: 0;
  font-size: 82px !important;
  font-weight: bold;

  &:hover {
    background-color: #ccced2 !important;
  }

  td {
    font-size: 1rem;
    &:hover > td {
      background-color: #ccced2 !important;
    }
  }
}

.row-index-0 {
  @include common();

  background-color: #b1cefe !important;
  color: #5f8fdf !important;

  &:hover > td {
    background-color: #b1cefe !important;
  }
}

.row-index-1 {
  @include common();

  background-color: #e7faf0 !important;
  color: #13ce66 !important;
}

.row-index-2 {
  @include common();

  background-color: #fef8ea !important;
  color: #f7ba2a !important;
}

.row-index-3 {
  @include common();

  background-color: #f5e9fd !important;
  color: #c26fcf !important;
}
</style>
<style scoped></style>
